import { useLocation } from 'react-router-dom';

export const useQueryParam = (param: string) => {
    const { search } = useLocation();

    return new URLSearchParams(search).get(param) || '';
};
